<mat-button-toggle-group [value]="selectedLabelKey" class="toggle-tabs">
  @for (data of labelData; track identify($index)) {
  <mat-button-toggle
    [value]="data.labelKey"
    (click)="selectTab(data)"
    [hasViewPermission]="data.permission"
    [iconExtraStyles]="lockIconStyles"
    [alignRight]="true"
    class="toggle"
  >
    @if (data.iconName) {
    <firebird-web-icon
      class="icons"
      [name]="data.iconName"
      width="16px"
      height="16px"
    >
    </firebird-web-icon>
    }
    <span [translate]="data.labelKey"></span>
  </mat-button-toggle>
  }
</mat-button-toggle-group>
